<template>
  <div class="briefs-usuarios">
    <b-card no-header>
      <b-row>
        <b-col cols="12">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="usuarios" 
              :fields="fields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(usuario)="data">
              {{ data.item.usuario.trim() + ' - ' + data.item.usuarioRol.trim() }}
            </template>
            <template v-slot:cell(asignado)="data">
              <b-form-checkbox
                  v-model="data.item.asignado"
                  :value="true"
                  :unchecked-value="false">
              </b-form-checkbox> 
            </template>
          </b-table>
        </b-col>
      </b-row>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancel">Cancelar</b-button>
      </div>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefs/getField',
  mutationType: 'briefs/updateField',
});

export default {
  name: 'BriefsUsuariosSeleccion',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    briefId: {
      type: Number,
      default: 0
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'usuario',
          label: 'Usuarios',
          // sortable: true
        },
        {
          key: 'asignado',
          label: '',
          class: 'text-center'
          // sortable: true
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'usuarios',
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('briefs/getUsuariosBrief', this.briefId)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.tableBusy = false);
    },
    agregar () {
      this.$refs.searchUsuarioModal.show();
    },
    incluirUsuario(usuario) {
      // this.tableBusy = true;
      // this.$store.dispatch('presupuestosinternosusuarios/incluirUsuario', usuario.id)
      //   .finally(() => this.tableBusy = false);
    },
    excluirUsuario(usuario) {
      // this.tableBusy = true;
      // this.$store.dispatch('presupuestosinternosusuarios/excluirUsuario', usuario.id)
      //   .finally(() => this.tableBusy = false);
    },
    save() {
      this.showSpinner();
      this.$store.dispatch('briefs/setUsuariosBrief')
        .then(() => this.$emit('close'))
        .finally(() => this.hideSpinner());
    },
    cancel() {
      this.$emit('close');
    }
  },
  watch: {
  }    
}
</script>

<style>
  .briefs-usuarios .table thead th {
    border-top: none;
  }
</style>
